<button id="show-founder-btn" (click)="showSuccess = true" hidden class="btn btn-primary">Show Founder Message</button>
<ds-modal-one
  [modalOneInput] = "modalOneConfig">
  <div class="modal-content-wrapper" modal-body>
    <div class="title-description">
        <h6 class="body-title">{{'onboarding_feedback' | translate}}</h6>
    </div>
    <div class="info-box">
        <div class="info-content">
            <p class="content-one"><strong>{{'need_help_along' | translate}}</strong></p>
            <p class="content-two">{{'virtual_assistant_help' | translate}}</p>
        </div>
        <div class="icon-container">
            <img [src]="ICONS.CHAT" alt="">
        </div>
    </div>
  </div>
  <div modal-footer class="m-0 d-flex justify-content-start gap-2">
    <ds-button
        [buttonInput]="bookNowConfig"
        (btnClick)="onOptionChange(false)">
    </ds-button>
    <ds-button
        [buttonInput]="feedbackYesConfig"
        (btnClick)="onOptionChange(true)">
    </ds-button>
  </div>
</ds-modal-one>


<ds-modal-one [modalOneInput] ="bookModalConfig">
    <div class="block padding-0 padding-bottom-10 heightCalc-22" modal-body>
        <div class="row virtualAssistant" style="height: 100%">
            <div class="d-flex justify-content-between w-100pc flex-column position-relative">
                <iframe [src]="safeCalendlyUrl"
                    width="100%"
                    height="100%"
                    frameborder="0"
                    style="border: 0"
                    allowfullscreen>
                </iframe>
            </div>
        </div>
    </div>
    <div modal-footer class="m-0 d-flex justify-content-start gap-2">
        <ds-button
            [buttonInput]="backConfig"
            (btnClick)="goBackFromCalendly()">
        </ds-button>
        <ds-button
            [buttonInput]="doneConfig"
            (btnClick)="onSubmitFeedback()">
        </ds-button>
    </div>
</ds-modal-one>